"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = dictateInterims;

var _setDictateInterims = require("../actions/setDictateInterims");

var DEFAULT_STATE = [];

function dictateInterims() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case _setDictateInterims.SET_DICTATE_INTERIMS:
      state = payload.dictateInterims;
      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJERUZBVUxUX1NUQVRFIiwiZGljdGF0ZUludGVyaW1zIiwic3RhdGUiLCJwYXlsb2FkIiwidHlwZSIsIlNFVF9ESUNUQVRFX0lOVEVSSU1TIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3JlZHVjZXJzL2RpY3RhdGVJbnRlcmltcy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTRVRfRElDVEFURV9JTlRFUklNUyB9IGZyb20gJy4uL2FjdGlvbnMvc2V0RGljdGF0ZUludGVyaW1zJztcblxuY29uc3QgREVGQVVMVF9TVEFURSA9IFtdO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBkaWN0YXRlSW50ZXJpbXMoc3RhdGUgPSBERUZBVUxUX1NUQVRFLCB7IHBheWxvYWQsIHR5cGUgfSkge1xuICBzd2l0Y2ggKHR5cGUpIHtcbiAgICBjYXNlIFNFVF9ESUNUQVRFX0lOVEVSSU1TOlxuICAgICAgc3RhdGUgPSBwYXlsb2FkLmRpY3RhdGVJbnRlcmltcztcbiAgICAgIGJyZWFrO1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgcmV0dXJuIHN0YXRlO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUEsSUFBTUEsYUFBYSxHQUFHLEVBQXRCOztBQUVlLFNBQVNDLGVBQVQsR0FBbUU7RUFBQSxJQUExQ0MsS0FBMEMsdUVBQWxDRixhQUFrQzs7RUFBQTtFQUFBLElBQWpCRyxPQUFpQixRQUFqQkEsT0FBaUI7RUFBQSxJQUFSQyxJQUFRLFFBQVJBLElBQVE7O0VBQ2hGLFFBQVFBLElBQVI7SUFDRSxLQUFLQyx3Q0FBTDtNQUNFSCxLQUFLLEdBQUdDLE9BQU8sQ0FBQ0YsZUFBaEI7TUFDQTs7SUFFRjtNQUNFO0VBTko7O0VBU0EsT0FBT0MsS0FBUDtBQUNEIn0=